module.exports = __webpack_public_path__ + "static/media/entregarinju8.590d0786.webp";